import { ThemeProvider } from '@capturi/ui-theme'
import { Global } from '@emotion/react'
import type { ComponentProps, FC } from 'react'

import globalStyles from './globalStyles'

const CapturiThemeProvider: FC<ComponentProps<typeof ThemeProvider>> = ({
  children,
  ...props
}) => {
  return (
    <ThemeProvider {...props} resetCSS>
      <Global styles={globalStyles} />
      {children}
    </ThemeProvider>
  )
}

export default CapturiThemeProvider
